import React from 'react';

const RemoveFromList = ({ ...rest }) => {
  return (
    <svg
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M12 4H0V6H12V4ZM12 0H0V2H12V0ZM0 10H8V8H0V10Z" fill="#7EFCF0" />
      <path
        d="M10.9998 9.49998L12.4998 11.0378L15.9998 7.49998"
        stroke="#7CFCEF"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default RemoveFromList;
